"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { Image as ImageIcon, Video, GraduationCap, Presentation, ArrowUpRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "images",
  title: "KI-generierte Bilder",
  useCase: "Steigere Social-Media-Interaktionen um bis zu 40 %",
  icon: ImageIcon,
  size: "col-span-1 md:col-span-2 md:row-span-2",
  image: "https://just-shepherd.10web.cloud/wp-content/uploads/2026/02/Sneaker_Final.png",
  href: "/MedienPage"
}, {
  id: "video",
  title: "KI-generierte Videos",
  useCase: "Steigere Deine Conversion-Rate um bis zu 80 %",
  icon: Video,
  size: "col-span-1 md:col-span-2 md:row-span-1",
  image: "https://just-shepherd.10web.cloud/wp-content/uploads/2026/02/Video_Final.jpg",
  href: "/MedienPage"
}, {
  id: "elearning",
  title: "E-Learnings & Tutorials",
  useCase: "Halbiere die Zeit für Trainingserstellung",
  icon: GraduationCap,
  size: "col-span-1 md:col-span-1 md:row-span-1",
  image: "https://just-shepherd.10web.cloud/wp-content/uploads/2026/02/E-Learning.jpg",
  href: "/MedienPage"
}, {
  id: "presentations",
  title: "Präsentationen & Websites",
  useCase: "Gewinne bis zu 30% mehr Deals",
  icon: Presentation,
  size: "col-span-1 md:col-span-1 md:row-span-1",
  image: "https://just-shepherd.10web.cloud/wp-content/uploads/2026/02/Presentation.jpg",
  href: "/MedienPage"
}];
export default function TheOutputSpectrum() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-output-spectrum" className="dark bg-background text-foreground py-20 px-4 md:px-8 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_100px_rgba(0,0,0,0.8)] z-10" />

      <div className="max-w-7xl mx-auto relative z-20">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4 bg-gradient-to-r from-white to-white/60 bg-clip-text text-transparent">Das bietet die Schmiede</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">Entdecke unsere leistungsstarken Medienformate – entwickelt, um Wachstum und Engagement zu beschleunigen.</p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 auto-rows-[250px]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
          {services.map((service, i) => <Link key={service.id} to={service.href} data-index={i} className={cn("group relative overflow-hidden rounded-2xl border border-white/10 bg-card/5 shadow-lg transition-all duration-500 hover:border-primary/50 hover:shadow-[0_0_30px_-5px_var(--color-primary)]", service.size)}>
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-105" style={{
            backgroundImage: `url(${service.image})`
          }} />

              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-40" />

              <div className="absolute inset-0 bg-primary/90 backdrop-blur-sm opacity-0 transition-all duration-300 group-hover:opacity-95 flex flex-col items-center justify-center p-6 text-center" />

              <div className="absolute inset-0 p-6 flex flex-col justify-end md:justify-between">
                <div className="self-end opacity-0 -translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
                  <ArrowUpRight className="w-6 h-6 text-white" />
                </div>

                <div className="mt-auto">
                  <div className="transform transition-transform duration-300 group-hover:-translate-y-2">
                    <div className="mb-3 inline-flex items-center justify-center rounded-lg bg-background/20 p-3 backdrop-blur-md border border-white/10 group-hover:bg-white/10 group-hover:border-white/20 transition-colors">
                      <service.icon className="w-6 h-6 text-primary fill-white/10" />
                    </div>
                    <h3 className="text-xl md:text-2xl font-bold text-white leading-tight">
                      {service.title}
                    </h3>
                  </div>

                  <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-300 group-hover:grid-rows-[1fr]">
                    <div className="overflow-hidden">
                      <p className="mt-3 text-lg font-medium text-primary-foreground/90 border-l-2 border-primary pl-3">
                        {service.useCase}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}